import React from 'react';
import {
  Typography,
  Box,
  useTheme,
} from '@mui/material';
import { PageLayout } from '../../components/footer/PageLayout';
import { ContentSection } from '../../components/footer/ContentSection';

export const CookiesPage: React.FC = () => {
  const theme = useTheme();

  return (
    <PageLayout
      title="Cookie Policy"
      subtitle="Learn about how we use cookies and similar technologies on our platform."
    >
      <ContentSection>
        <Box sx={{ maxWidth: '800px', mx: 'auto' }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            What Are Cookies?
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.6 }}>
            Cookies are small text files that are placed on your computer or mobile device when you visit our website. They help us provide you with a better experience by remembering your preferences and settings.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            How We Use Cookies
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.6 }}>
            We use cookies to improve your experience on our platform, analyze how you use our services, and provide personalized content and advertisements.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            Types of Cookies We Use
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.6 }}>
            We use essential cookies, performance cookies, functionality cookies, and targeting cookies to provide you with the best possible experience.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            Managing Cookies
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.6 }}>
            You can control and manage cookies through your browser settings. However, disabling certain cookies may affect the functionality of our platform.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            Third-Party Cookies
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.6 }}>
            We may use third-party services that set their own cookies. These services have their own privacy policies and cookie practices.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            Updates to This Policy
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.6 }}>
            We may update this cookie policy from time to time. We will notify you of any changes by posting the new policy on this page.
          </Typography>

          <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2 }}>
            Contact Us
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.6 }}>
            If you have any questions about our use of cookies, please contact us at privacy@careva.ai.
          </Typography>
        </Box>
      </ContentSection>
    </PageLayout>
  );
};
